<template>
  <div>
    <p class="title line-height-48 hei-24">
      分享海报样式示意
    </p>
    <div class="block postBlock" style="background-image: url('../../../../static/img/live-share-background.jpg')">
      <!-- <div class="siteWrapper">
        <div class="live-share-logo">
          <el-image v-if="logo" class="wid-25 hei-25" :src="logo" />
        </div>
        <div class="siteName">
          店铺名称
        </div>
        <div v-if="showAddress" class="siteAddress">
          店铺地址
        </div>
      </div> -->
      <div class="container">
        <div class="picWrapper">
          <img v-if="data.img" :src="`${data.img}?imageView2/1/w/500/h/500`" />
        </div>
        <div class="bottom">
          <div class="left">
            <p class="live-name">
              {{ data.title ? data.title : "活动名称" }}
            </p>
            <p class="description">
              {{ data.description ? data.description : "" }}
            </p>
          </div>
          <div class="right">
            <img src="../../../../static/img/live-share-QRCode.jpg" />
            <p>扫码/长按识别</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data', 'showAddress', 'logo'],
};
</script>
